import React from 'react'
import { EditOutlined } from "@mui/icons-material";
import { Button } from "@mui/material";
import { Link, useParams } from "react-router-dom";
import { toast } from "react-toastify";

import EnableDisableButton from "components/Shared/EnableDisableButton";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";

import TransshipmentBasicDetail from "./TranshipmentController/TransshipmentBasicDetail";

import { TransshipmentDetailContext, useTransshipmentDetailContext } from "contexts/TransshipmentDetailContext";

import { useGetTransshipmentDetailQuery, useUpdateTransshipmentMutation } from "store/services/transhipmentApi";


const TransshipmentDetailScreen = () => {

  const { id } = useParams();

  const breadcrumb = [
    { title: "Transshipment", path: "/app/crm/transshipment/list" },
    { title: "Transshipment Detail" }
  ]

  // RTK Query
  const {
    data: transshipmentDetail,
    isLoading: loadingTransshipment,
    error,
  } = useGetTransshipmentDetailQuery(id);

  return (
    <TransshipmentDetailContext.Provider value={{ transshipmentDetail, loadingTransshipment }}>
      <BreadcrumbLayout breadcrumbs={breadcrumb}
        isBusy={loadingTransshipment}
        headerActions={<PageActions />} >
        <BreadcrumbLayout.Error error={error} />
        <BreadcrumbLayout.Paper>
          <TransshipmentBasicDetail />
        </BreadcrumbLayout.Paper>
      </BreadcrumbLayout>
    </TransshipmentDetailContext.Provider>
  )
}

export default TransshipmentDetailScreen;

const PageActions = () => {
  const { transshipmentDetail, loadingTransshipment }
    = useTransshipmentDetailContext();

  // RTK Query
  const [updateVehicleMaintenance, { isLoading: updatingTransshipment }]
    = useUpdateTransshipmentMutation();

  // methods
  const handelToggleTransshipmentStatus = async () => {
    try {
      await updateVehicleMaintenance({
        _id: transshipmentDetail._id,
        isActive: !transshipmentDetail.isActive,
      }).unwrap();
      toast.info(`maintenance ${transshipmentDetail.isActive ? "Disable" : "Enable"} !`);
    } catch (error) {
      toast.error(error?.data.message ?? "Could Not Update Status");
    }
  }

  return (
    <div className="flex space-x-4">
      <EnableDisableButton
        isActive={transshipmentDetail?.isActive}
        loading={loadingTransshipment || updatingTransshipment}
        onClick={handelToggleTransshipmentStatus}
      />
      <Link to={`/app/crm/transshipment/${transshipmentDetail?._id}/edit`}>
        <Button startIcon={<EditOutlined />} variant="contained">
          Edit
        </Button>
      </Link>
    </div>
  );
};
